import { Row, Col, Typography } from 'antd';
import MoneyDisplay from "./MoneyDisplay";

const { Text } = Typography;

const boxStyle = {
    marginBottom: '25px'
};

const colStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center' };

const IntentAggregations = (props) => {
  const income = Number(props.data?.income_sum?.total_amount ?? 0);
  const expense = Number(props.data?.expense_sum?.total_amount ?? 0);
  const diff = income - expense;
  const profitability = income > 0 ? (diff / income) * 100 : null;

  let profitabilityContent;
  let profitabilityColor;
  if (profitability === null) {
    profitabilityContent = '—';
    profitabilityColor = 'grey';
  } else {
    const sign = profitability > 0 ? '+ ' : profitability < 0 ? '- ' : '';
    profitabilityContent = `${sign}${Math.abs(profitability).toFixed(1)} %`;
    profitabilityColor = profitability > 0 ? 'green' : profitability < 0 ? 'red' : 'grey';
  }

  return (
    <Row style={boxStyle} justify="space-around" align="top">
      <Col span={6} style={colStyle}>
        <Text><b>{props.expensesTitleOverride || 'ODHODKI'}</b></Text>
        <MoneyDisplay size='big' type='EXPENSE' val={props.data?.expense_sum?.total_amount} />
      </Col>
      <Col span={6} style={colStyle}>
        <Text><b>{props.incomesTitleOverride || 'PRIHODKI'}</b></Text>
        <MoneyDisplay size='big' type='INCOME' val={props.data?.income_sum?.total_amount} />
      </Col>
      <Col span={6} style={colStyle}>
        <Text><b>RAZLIKA</b></Text>
        <MoneyDisplay size='big' type='TAX' val={diff} />
      </Col>
      <Col span={6} style={colStyle}>
        <Text><b>PROFITABILNOST</b></Text>
        <Text style={{ color: profitabilityColor, fontSize: '30px', fontWeight: 1000 }}>
          {profitabilityContent}
        </Text>
      </Col>
    </Row>
  );
};

export default IntentAggregations;
